import styled from '@emotion/styled';
import { rgba } from 'polished';
import React, { useRef, useState } from 'react';
import { Dialog } from '../../../components/dialog/Dialog';
import { typography } from '../../../styles';

interface IProps {
  inset?: boolean;
  bordered?: boolean;
  options: { value: string; label: string; subText?: string }[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  dialogTitle: string;
}

const Button = styled.button<{ inset?: boolean; bordered?: boolean }>`
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  font-weight: 500;
  background: ${(props) =>
    props.inset ? props.theme.shades.primary1 : '#fff'};
  position: relative;
  width: 100%;

  border: ${(props) =>
    props.bordered ? `1px solid ${props.theme.colors.primary}` : 'none'};

  text-align: start;
  padding: ${(props) =>
    props.bordered ? ' 21px 20px 17px 12px' : ' 15px 20px 15px 12px'};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Ul = styled.ul`
  outline: none;
`;

const ListItem = styled.li`
  border-bottom: 1px solid rgba(30, 61, 90, 0.2);
  &:hover {
    box-shadow: 0 3px 0 0 ${(props) => rgba(props.theme.colors.primary, 1)};
    border-color: transparent;
    cursor: pointer;
  }
`;
const ListButton = styled.button<{ selected?: boolean; hasSubtext: boolean }>`
  ${typography.body}
  width: 100%;
  text-align: start;
  padding: ${(props) => (props.hasSubtext ? '14px 0 13px 0' : '23px 0 22px 0')};
  line-height: 18px;
  cursor: pointer;
  font-weight: bold;
  opacity: ${(props) => (props.selected ? '0.3' : '1')};
`;

const SubText = styled.span<{ selected?: boolean }>`
  ${typography.bodySmall}
  opacity: ${(props) => (props.selected ? '1' : '0.6')};
`;

export const MobileDropdown: React.FC<IProps> = ({
  onChange,
  options,
  value,
  placeholder,
  dialogTitle,
  bordered,
  inset,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLUListElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Button
        bordered={bordered}
        ref={buttonRef}
        inset={inset}
        onClick={() => setOpen(true)}
        aria-haspopup="listbox"
      >
        {options.find((i) => i.value === value)?.label ?? placeholder}
        <svg width="16" height="10" viewBox="0 0 16 10">
          <path
            fill="none"
            fillRule="evenodd"
            stroke="#163E63"
            strokeWidth="2"
            d="M14.545455.909091L8 8.272727 1.454545.909091"
          ></path>
        </svg>
      </Button>
      {open && (
        <Dialog onClose={() => setOpen(false)} title={{ label: dialogTitle }}>
          <Ul ref={ref} tabIndex={-1} role="listbox">
            {options.map((option) => (
              <ListItem key={option.value} role="option">
                <ListButton
                  hasSubtext={!!option.subText}
                  selected={option.value === value}
                  onClick={() => {
                    onChange(option.value);
                    setOpen(false);
                    buttonRef?.current?.focus();
                  }}
                >
                  <p>{option.label}</p>
                  {option.subText && <SubText>{option.subText}</SubText>}
                </ListButton>
              </ListItem>
            ))}
          </Ul>
        </Dialog>
      )}
    </>
  );
};
